<template>
  <div
    v-if="showProgress"
    class="attachment-progress"
  >
    <div class="attachment-progress__header">
      <div class="attachment-progress__title">
        <component
          :is="config.icon"
          :style="{ color: config.textColor }"
        />

        <div
          class="attachment-progress__message"
          :style="{ color: config.textColor }"
        >
          <span>
            {{ statusMessage.prefix }}
          </span>

          <strong>
            {{ statusMessage.highlight }}
          </strong>

          <span
            v-if="statusMessage.suffix"
            class="attachment-progress__suffix"
          >
            {{ statusMessage.suffix }}
          </span>
        </div>
      </div>

      <span class="attachment-progress__limit">
        {{ maxSizeMB }}MB
      </span>
    </div>

    <a-progress
      :percent="percentage"
      :show-info="false"
      :stroke-color="config.barColor"
      :stroke-linecap="'round'"
      :size="[999, 8]"
    />

    <div class="attachment-progress__hint">
      Si los archivos superan los {{ maxSizeMB }} MB, súbelos a un
      enlace externo (como Google Drive o Wetransfer) y colócalo en
      el cuerpo del correo.
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRef } from "vue";

import { useAttachmentProgress }
from "@/app/shared/composables/useAttachmentProgress";

const props = withDefaults(
  defineProps<{
    files?: File[];
    maxSizeMB?: number;
  }>(),
  {
    files: () => [],
    maxSizeMB: 10,
  }
);

const {
  percentage,
  statusMessage,
  showProgress,
  config,
} = useAttachmentProgress(
  toRef(props, "files"),
  {
    maxSizeMB: props.maxSizeMB,
  }
);
</script>

<style scoped lang="sass">
.attachment-progress
  margin-top: 12px
  display: flex
  flex-direction: column
  gap: 2px

  &__header
    display: flex
    justify-content: space-between
    align-items: center

  &__title
    display: flex
    align-items: center
    gap: 6px
    font-size: 13px
    // font-weight: 600

  // &__title-text
  //   color: #d81b60
  //   font-size: 13px
  //   font-weight: 600

  &__limit
    font-size: 12px
    color: #8c8c8c

  &__message
    display: flex
    align-items: center
    gap: 4px
    font-size: 13px

    strong
      font-weight: 600

  &__suffix
    color: #8c8c8c
    font-weight: 400
  &__hint
    font-size: 12px
    color: #8c8c8c

:deep(.ant-progress)
  margin: 0 !important
  line-height: 1 !important

:deep(.ant-progress-inner)
  vertical-align: top !important

:deep(.ant-progress-outer)
  padding-inline-end: 0 !important
</style>